/* ============================================================================
   §5.2 · Header — mobile drawer toggle.

   The `hidden` attribute is the whole mechanism rather than a class: it is
   the accessible default, so the drawer is correctly hidden from assistive
   tech before this file has even parsed.
   ========================================================================= */
(function () {
  'use strict';

  document.querySelectorAll('[data-header]').forEach(function (header) {
    var toggle = header.querySelector('[data-header-toggle]');
    var drawer = header.querySelector('[data-header-drawer]');
    if (!toggle || !drawer) return;

    function setOpen(open) {
      drawer.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    toggle.addEventListener('click', function () {
      setOpen(drawer.hidden);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || drawer.hidden) return;
      setOpen(false);
      toggle.focus();
    });

    // Crossing the desktop breakpoint with the drawer open would otherwise
    // leave `aria-expanded="true"` on a button CSS has just hidden.
    var wide = window.matchMedia('(min-width: 900px)');
    wide.addEventListener('change', function () {
      if (wide.matches) setOpen(false);
    });
  });
})();
